import React, { useState } from "react";
import { DialogContainer, Button, TextField, FontIcon } from "react-md";
import { Row, Col } from "react-flexbox-grid";
import successGif from "../../../../../../assets/images/done-animation.gif";
import "../../styles/navigoDashboardStyles.scss";
import { CANCEL_APP_OPTION } from "../../helper/appointmentConstants";

export function CancelAppointmentDialog({
  state,
  show,
  setShowCancelAppDialog,
  setCancelAppOption,
  appToBeCancelled,
}) {
  const getButtonStyle = (color) => {
    const base = {
      cursor: "pointer",
      marginLeft: "10px",
      minWidth: "125px",
      textTransform: "none",
      fontSize: "medium",
      borderRadius: "5px",
      color: "#FFFFFF",
    };

    switch (color) {
      case "zyOrange":
        return { ...base, backgroundColor: "#F77F11" };
      case "zyGreen":
        return { ...base, backgroundColor: "#04C9D3" };
      case "zyDisabled":
        return { ...base, backgroundColor: "#C2C2C2" };
      default:
        return { ...base, backgroundColor: "#EBEBEB", color: "#333333" };
    }
  };

  function handleClose() {
    setShowCancelAppDialog(false);
    setCancelAppOption(CANCEL_APP_OPTION.NONE);
  }

  function cancelWithRefundApplicable() {
    return (
      <>
        <div style={{ textAlign: "center", marginBottom: "15px" }}>
          Rs {appToBeCancelled?.price} Refund is applicable upon cancellation of
          this appointment.
        </div>
        <div style={{ marginTop: "25px", textAlign: "center" }}>
          <Button
            raised
            style={getButtonStyle("zyOrange")}
            onClick={() => {
              setCancelAppOption(CANCEL_APP_OPTION.CANCEL_WITH_REFUND);
            }}
          >
            Cancel with refund
          </Button>
          <Button
            raised
            style={getButtonStyle("zyGrey")}
            onClick={() => {
              setCancelAppOption(CANCEL_APP_OPTION.CANCEL_WITHOUT_REFUND);
            }}
          >
            Cancel without refund
          </Button>
        </div>
      </>
    );
  }
  function cancelWithRefundNotApplicable() {
    return (
      <>
        <div style={{ textAlign: "center", marginBottom: "15px" }}>
          Refund is <b>NOT</b> applicable as appointment is cancelled within 24
          hours of scheduled time.
        </div>
        <div style={{ marginTop: "25px", textAlign: "center" }}>
          <Button
            raised
            style={getButtonStyle("zyOrange")}
            onClick={() => {
              setCancelAppOption(CANCEL_APP_OPTION.CANCEL_WITHOUT_REFUND);
            }}
          >
            Cancel without refund
          </Button>
          <Button
            raised
            style={getButtonStyle("zyGrey")}
            onClick={() => {
              setCancelAppOption(CANCEL_APP_OPTION.CANCEL_WITH_REFUND);
            }}
          >
            Cancel with refund
          </Button>
        </div>
      </>
    );
  }
  function cancelAppointment() {
    return (
      <>
        <div style={{ marginTop: "25px", textAlign: "center" }}>
          <Button
            raised
            style={getButtonStyle("zyOrange")}
            onClick={() => {
              setCancelAppOption(CANCEL_APP_OPTION.JUST_CANCEL);
            }}
          >
            Confirm
          </Button>
          <Button
            raised
            style={getButtonStyle("zyGrey")}
            onClick={() => {
              handleClose();
            }}
          >
            Go back
          </Button>
        </div>
      </>
    );
  }

  return appToBeCancelled == null ? (
    <></>
  ) : (
    <div className="custom-dialog-overlay">
      <DialogContainer
        id="cancel-appointment-dialog"
        visible={show}
        onHide={() => {}}
        focusOnMount={false}
        autosizeContent
        width={"700px"}
        dialogStyle={{
          borderRadius: "10px",
          padding: "15px 15px 5px 15px",
          position: "relative",
          zIndex: 101,
        }}
      >
        <div style={{ fontFamily: "Montserrat", color: "#000" }}>
          {/* Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "15px",
            }}
          >
            <div
              style={{
                margin: 0,
                textAlign: "center",
                width: "100%",
                fontWeight: "600",
              }}
            >
              {"Are you sure you want to cancel the appointment?"}
            </div>
            <FontIcon
              style={{
                cursor: "pointer",
                fontSize: "22px",
                color: "#777",
              }}
              onClick={() => {
                handleClose();
              }}
            >
              close
            </FontIcon>
          </div>
          {state === CANCEL_APP_OPTION.JUST_CANCEL && cancelAppointment()}
          {state === CANCEL_APP_OPTION.CANCEL_WITH_REFUND &&
            cancelWithRefundApplicable()}
          {state === CANCEL_APP_OPTION.CANCEL_WITHOUT_REFUND &&
            cancelWithRefundNotApplicable()}
        </div>
      </DialogContainer>
    </div>
  );
}
